/**----------------------------------------------------------------------------------------------------
 * Classification and colors for Chloride for flightprofiles.
 *
 * European Union Public Licence V. 1.2
 * EUPL © the European Union 2007, 2016
 *
 * Modified: 2026, Eddy Scheper, ARIS BV
 */

import {createFillStyle} from "./OLUtils";
import ColorTable from "./ColorTable";

/**-----------------------------------------------------------------------------
 */
export default class FlightColorTable extends ColorTable {

  /**-----------------------------------------------------------------------------
   */
  constructor() {
    super();
  }

  /**-----------------------------------------------------------------------------
   * Initialize colors with keys from low to high.
   * @private
   */
  init() {
    let strKeys, colors, texts;
    let i, len;

    // Init keys, styles and texts.
    strKeys = [];
    colors = [];
    texts = [];

    //   0		0 0 127
    //   150		0 0 250
    //   300		0 88 255
    //   500		0 196 255
    //   1000		60 255 186
    //   1500		147 255 99
    //   3000		234 255 12
    //   5000		255 159 0
    //   10000		255 59 0
    //   > 15000		182 0 0
    this.add(strKeys, colors, texts, "0", "rgb(0, 0, 127)", "0");
    this.add(strKeys, colors, texts, "150", "rgb(0, 0, 250)", "150");
    this.add(strKeys, colors, texts, "300", "rgb(0, 88, 255)", "300");
    this.add(strKeys, colors, texts, "500", "rgb(0, 196, 255)", "500");
    this.add(strKeys, colors, texts, "1000", "rgb(60, 255, 186)", "1000");
    this.add(strKeys, colors, texts, "1500", "rgb(147, 255, 99)", "1500");
    this.add(strKeys, colors, texts, "3000", "rgb(234, 255, 12)", "3000");
    this.add(strKeys, colors, texts, "5000", "rgb(255, 159, 0)", "5000");
    this.add(strKeys, colors, texts, "10000", "rgb(255, 59, 0)", "10000");
    this.add(strKeys, colors, texts, "15000", "rgb(182, 0, 0)", "15000");

    // Fill keys, styles and texts.
    for (i = 0, len = strKeys.length; i < len; i++) {
      this.keys.push(parseInt(strKeys[i]));
      this.styles.push(createFillStyle(colors[i],null));
      this.texts.push(texts[i]);
    }

    // Create nodata style and text.
    this.noDataStyle = createFillStyle("white","black");
    this.noDataText = "Onbekend";

    // Fill reversed keys.
    this.keysReversed = this.keys.slice();
    this.keysReversed.reverse();
  }
}
